import { Controller, Post, Body, Req } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { NotificationDTO } from './dto/notifications.dto';
import { AllNotificationsResponse, NotificationResponse } from '@gtpl/shared-models/hrms';
import { NotificationRequest } from './dto/notifications.request';
import { NotificationsService } from './notifications.service';



@ApiTags('notifications')
@Controller('notifications')
export class NotificationsController {
    constructor(
        private service: NotificationsService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler,
    ){}

    @Post('/createNotification')
    async createNotification(@Body() DTO: NotificationDTO, isUpdate: boolean = false): Promise<NotificationResponse>{
        try{
            return await this.service.createNotification(DTO, false);
        }catch(error){
            return this.applicationExceptionHandler.returnException(NotificationResponse, error);
        }
    }

    @Post('/updateNotification')
    async updateNotification(@Body() DTO: NotificationDTO, isUpdate: boolean = false): Promise<NotificationResponse>{
        try{
            return await this.service.createNotification(DTO, true);
        }catch(error){
            return this.applicationExceptionHandler.returnException(NotificationResponse, error);
        } 
    }

    @Post('/getAllNotifications')
    async getAllNotifications(): Promise<AllNotificationsResponse>{
        try{
            return await this.service.getAllNotifications();
        }catch(error){
            return this.applicationExceptionHandler.returnException(AllNotificationsResponse, error);
        }
    }

    @Post('/getAllActiveNotifications')
    async getAllActiveNotifications(): Promise<AllNotificationsResponse>{
        try{
            return await this.service.getAllActiveNotifications();
        }catch(error){
            return this.applicationExceptionHandler.returnException(AllNotificationsResponse, error);
        }
    }

    @Post('/activateOrDeactivateNotification')
    async activateOrDeactivate(@Body() req: NotificationRequest): Promise<NotificationResponse>{
        try{
            return await this.service.activateOrDeactivateNotification(req);
        }catch(error){
            return this.applicationExceptionHandler.returnException(NotificationResponse, error)
        }
    }
}
